import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


// Fix (2026-09-05): a FastAPI 422 body has `detail` as an ARRAY of Pydantic
// error objects ({type, loc, msg, ...}), not a string. Passing that array
// straight into toast.error() makes React try to render objects as children,
// which throws and blanks the whole app (no error boundary catches it). This
// always returns a safe string, whatever shape `detail` is.
export function getErrorMessage(err, fallback = 'Something went wrong') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (Array.isArray(detail) && detail.length) {
    return detail.map((d) => (typeof d === 'string' ? d : d?.msg || JSON.stringify(d))).join('; ');
  }
  if (detail && typeof detail === 'object') return detail.msg || JSON.stringify(detail);
  return fallback;
}
